import { forwardRef, type InputHTMLAttributes } from 'react';

type CheckboxSize = 'sm' | 'md' | 'lg';

export interface CheckboxProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'size'> {
  /** チェックボックスのサイズ */
  size?: CheckboxSize;
  /** ラベルテキスト */
  label?: string;
  /** エラー状態 */
  error?: boolean;
  /** 追加のクラス名 */
  className?: string;
}

/**
 * AIPデザインシステムのチェックボックスコンポーネント
 */
export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  ({ size = 'sm', label, error, className = '', ...props }, ref) => {
    return (
      <label className={`aip-checkbox ${className}`.trim()} data-size={size}>
        <span className="aip-checkbox__checkbox">
          <input
            ref={ref}
            type="checkbox"
            className="aip-checkbox__input"
            aria-invalid={error || undefined}
            {...props}
          />
        </span>
        {label && <span className="aip-checkbox__label">{label}</span>}
      </label>
    );
  }
);

Checkbox.displayName = 'Checkbox';

export default Checkbox;

